export default {
  name: 'query',
  config: {
    baseURL: process.env.VUE_APP_API_BASE_URL
    // baseURL: `${process.env.VUE_APP_API_BASE_URL}/api`
    // baseURL: 'https://sls-cus-dev-api-core-app.azurewebsites.net/api'
  }
};
